:host {
  display: block;
}

.color-swatch-button {
  @apply p-2 flex flex-col items-center justify-center w-[100px] h-[80px];
  @apply border border-solid outline-none cursor-pointer;
  @apply font-ico-body text-center;

  border-radius: var(--border-radius-base);

  border-color: var(--clrs-border-button-color-selection);
  color: var(--clrs-text-button-color-selection);
  background-color: var(--clrs-bg-button-color-selection-default);
}

.color-swatch-button--selected {
  background-color: var(--clrs-bg-button-color-selection-selected);
  border-color: var(--clrs-border-button-color-selection-selected);
}

.color-swatch-button__label {
  color: var(--clrs-text-button-color-selection);

  @apply leading-none font-normal text-sm break-words;
}

.color-swatch-button__color-box {
  border-color: var(--clrs-border-button-color-selection);

  @apply box-border w-[60px] h-[40px] border-solid border mb-2;
}
